import * as Stores from './_stores';

export const _typeDefs = [
	Stores.UserStore.typeDefs,
	Stores.UIStore.typeDefs,
];